import type ISaasOverviewRepository from '@repositories/SaasOverviewRepository/ISaasOverviewRepository';
import { useQuery } from '@tanstack/react-query';
import { KEYS, repository } from '@repositories/Repository';

/**
 * GET /api/v1/statistics/product-subscription-overview
 * MZP2-6063 SaaSOps 대시보드 카드 집계.
 */

export type { SaasOverview } from '@repositories/SaasOverviewRepository/Types';

const SAAS_OVERVIEW_STALE_TIME_MS = 5 * 60 * 1000;

const repo = repository.get<ISaasOverviewRepository>(KEYS.SAAS_OVERVIEW_REPOSITORY);

const queryKey = {
  all: ['saasOverview'] as const,
  detail: (utilizationThreshold: number | null) =>
    [...queryKey.all, 'detail', utilizationThreshold] as const,
};

export const useSaasOverview = (utilizationThreshold?: number) =>
  useQuery({
    queryKey: queryKey.detail(utilizationThreshold ?? null),
    queryFn: () => repo.getOne(utilizationThreshold),
    staleTime: SAAS_OVERVIEW_STALE_TIME_MS,
  });
